import React, { useEffect, useId, useMemo, useState } from "react";

function isDark(){
    return useMemo(() => {
        return document.querySelector('html').classList.contains('theme-dark');
    }, [])
}


export function DarkModeToogle(){
    const darkMode = isDark()
    const [dark, setDark] = useState(darkMode);
    
    const id = useId();

    useEffect(() => {
        document.querySelector('html').classList.toggle('theme-dark', dark);
        localStorage.theme = dark ? 'dark' : 'light';
    }, [dark])


    return <div className="form-check my-3 column-input">
        <input className="form-check-input" type="checkbox" checked={dark} onChange={() => setDark(!dark)} id={id} />
        <label className="form-check-label" htmlFor={id}>
            Modo Escuro
        </label>
    </div>
}
